module.exports = __webpack_public_path__ + "static/img/中南大学湘雅医院.251b6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/中南大学湘雅医院.png
// module id = EiMk
// module chunks = 0 1 2 9